import React, { useContext } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { Container, Row, Logo } from '../../components';
import * as PATHS from '../../settings/paths';
import styles from './style.module.css';

import AuthContext from '../../context/Auth';

const Navbar = ({ sticky = false,isColored = false }) => {
  const authContext = useContext(AuthContext);

  return (
    <nav className={cn([styles.container, sticky && styles.isSticky , isColored && styles.colored])}>
      <Container>
        <Row between>
          <Logo height="50px" alt={'logo'} />

          <div>
            <ul className={styles.menu}>
              <li>
                <a href="/"> USD</a>
              </li>
              <li>
                <a href="/"> Agents</a>
              </li>
              {authContext.state.isLogged ? (
                <li>
                  <a href="/profile">Sezer Esim</a>
                </li>
              ) : (
                <>
                  <li>
                    <Link to={PATHS.LOGIN}>{'Login'}</Link>
                  </li>
                  <li>
                    <Link to={PATHS.REGISTER}>{'Sign Up'}</Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </Row>
      </Container>
    </nav>
  );
};

export default Navbar;
